import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {useFormContext} from "react-hook-form";
import Emitter from "../../../EventEmitter/EventEmitter";
import {ConstantEventEmitter} from "../../../data/ConstantEventEmitter";
import {portafolioService} from "../../../services/apiPortafolios";
import {convertToString, validArray} from "../../../util/functions";
import {GlobalConstants} from "../../../data/GlobalConstants";
import {modalSideService} from "../../../services/modalSideService";
import {ConstantsFormCrud} from "../../../data/RoutesFormCrud";
import {isEmpty} from "../../../util/is";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import Tooltip from "@mui/material/Tooltip";
import {Colors} from "../../../assets/colors/Colors";
import AgGridTable from "../../../components/AgGridTable";
import AccionesTable from "../../../components/AccionesTable";
import {modalCRUDService} from "../../../services/modalCRUDService";

const columnsDefMateriales = [
  {headerName: 'Estado',field: "estado", cellRenderer: "indicadorEstado",resizable: true, sortable: true, filter: true, width: 50, headerCheckboxSelection: true, checkboxSelection: true},
  {headerName: 'Código',field: "id",resizable: true, sortable: true, filter: true, width: 100},
  {headerName: 'Portafolio Material',field: "portafolioMaterial",resizable: true, sortable: true, filter: true, width: 200},
  {headerName: 'Total Materiales',field: "totalMateriales",resizable: true, sortable: true, filter: true, width: 100},
  {headerName: 'Acciones',field: "acciones", cellRenderer: "accionesComponent", resizable: true, sortable: true, filter: true, width: 100},
  {headerName: 'arrProductos',field: "jsProductos", resizable: false, sortable: false, filter: false, width: 0, hide: true}
];

const AccionesPortafoliosMateriales = ({params}) => {

  return(
    <AccionesTable params={params} accionesBasicas={false} deleteAccion={false} otrasAcciones={
      <i onClick={() => Emitter.emit(ConstantEventEmitter.eventCrudModalTable, {params, type: ConstantEventEmitter.handleClickViewProductosBySubportafolio})} style={{color: Colors.COLOR_AMOVIL_BLUE_DARK, cursor: "pointer"}} className="far fa-eye fa-lg mx-1"/>
    } />  )

}

const ExpandTablePortafoliosMateriales = ({properties}) => {

  const { getValues, dataList, tableRefPortafolios} = properties;
  const tableRefMateriales = useRef(null);

  const onCellValueChanged = params => {
    console.log(params)
  }

  const onRowDataUpdatedMateriales = params => {

    console.log("UPDATE DATA")

    let countSelected = 0;
    let total = 0;

    params.api.forEachNode( (node) => {

      if(node.data.selected){
        countSelected++;
      }
      total++;

      node.setSelected(node.data.selected, false, true);

    })

    Emitter.emit(ConstantEventEmitter.handleUpdateCounterItemsPortafoliosMaterial, {countSelected, total});

  }

  const handleSave = () => {

    let arrData = [];
    tableRefMateriales.current.api.forEachNode( (node) => {
      let data = node.data;
      data.selected = node.isSelected();
      arrData.push(data)
    })

    Emitter.emit(ConstantEventEmitter.eventUpdateDataPortafoliosMaterialesFromModal, arrData);

    modalCRUDService.clear();

  }

  const onSelectionChangedPortafoliosMateriales = () => {

    let countSelected = 0;
    let total = 0;

    tableRefMateriales.current.api.forEachNode(node => {
      if(node.isSelected()){
        countSelected++;
      }
      total++;
    });


    Emitter.emit(ConstantEventEmitter.handleUpdateCounterItemsPortafoliosMaterial, {countSelected, total});

  }

  useEffect(() => {
    tableRefMateriales.current.api.applyTransaction({ add: dataList });
  }, [dataList])

  return(
    <div className="w-100">

      <div className="w-100 d-flex justify-content-end align-items-center">

        <Tooltip title="Guardar" aria-label="guardar">
          <a onClick={() => handleSave()} className="icon-container-actions d-flex mr-0">
            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
          </a>
        </Tooltip>

      </div>

      <div className="mt-0 w-100 d-flex align-items-center justify-content-between">
        <AgGridTable
          referencia= {tableRefMateriales}
          columnDef = {columnsDefMateriales}
          dataList = {[]}
          height = {500}
          rowSelection={'multiple'}
          suppressRowClickSelection={true}
          onRowDataUpdated={onRowDataUpdatedMateriales}
          onCellValueChanged={onCellValueChanged }
          onSelectionChanged={onSelectionChangedPortafoliosMateriales}
          acciones={AccionesPortafoliosMateriales}
        />

      </div>
    </div>
  )

}


export default ExpandTablePortafoliosMateriales;
